import React from 'react'
import axios from 'axios'
import USMap from './USMap'
import StateMap from './StateMap'

/* Component for visualizing data on selected map. */
export default class Map extends React.Component {
    constructor(props) {
        super(props)
        /* Fetch query parameters from URL. */
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const state = this.titleCase(params.get('state') || '');
        /* Determine state. */
        this.state = {
            selectedState: state,
            data: null,
        }
    }

    componentDidMount() {
        /* Fetch COVID data. */
        axios.get("https://covid.psg.nexstardigital.net/covid.json")
        .then(response => {
            /* Update state. */
            this.setState({ data: response.data })
        })
    }

    titleCase(str) {
        /* Split string. */
        var splitStr = str.toLowerCase().split(' ');
        /* Iterate over string. */
        for (var i = 0; i < splitStr.length; i++) {
            /* Assign it back to the array */
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
        }
        /* Directly return the joined string */
        return splitStr.join(' ');
    }

    render() {
        /* Fetch state variables. */
        const { selectedState, data } = this.state
        /* Render. */
        return (
            (data !== null) &&
            <React.Fragment>
                { (selectedState === '') &&
                <React.Fragment>
                    <h4 className="text-left pb-3">
                        US Confirmed Coronavirus Cases by State
                    </h4>
                    <USMap
                        data={data}
                        analytics={this.props.analytics}
                    />
                </React.Fragment>
                }
                { (selectedState !== '') &&
                <React.Fragment>
                    <h4 className="text-left pb-3">
                        {selectedState} Confirmed Coronavirus Cases by {selectedState === 'Louisiana' ? 'Parish' : 'County'}
                    </h4>
                    <StateMap
                        data={data.states[selectedState]}
                        name={selectedState}
                        analytics={this.props.analytics}
                    />
                </React.Fragment>
                }
                <p className="text-left pt-3">
                    Sources: The Center for Systems Science and Engineering at <a
                        target="_blank" rel="noopener noreferrer" href="https://coronavirus.jhu.edu/map.html"
                    >
                        Johns Hopkins University
                    </a>
                </p>
            </React.Fragment>
        )
    }
}
